import axios from 'axios';
import { getUserData } from './storageService';

const BASE_URL = process.env.REACT_APP_API_URL || 'https://backend-c-0mxm.onrender.com';
const API_URL = BASE_URL.replace(/\/api$/, '');

const getAuthHeaders = () => {
  const user = getUserData();
  return {
    Authorization: `Bearer ${user?.userId || ''}`
  };
};

const api = axios.create({
  baseURL: `${API_URL}/api/tiktok-reports`,
});

api.interceptors.request.use((config) => {
  config.headers = { ...config.headers, ...getAuthHeaders() };
  return config;
});

const tiktokReportService = {
  // Get all reports
  getAll: async (params = {}) => {
    const response = await api.get('/', { params });
    return response.data;
  },

  // Get current week report
  getCurrentWeek: async () => {
    const response = await api.get('/current-week');
    return response.data;
  },

  // Get stats
  getStats: async () => {
    const response = await api.get('/stats');
    return response.data;
  },

  // Get single report
  getById: async (id) => {
    const response = await api.get(`/${id}`);
    return response.data;
  },

  // Create report
  create: async (data) => {
    const response = await api.post('/', data);
    return response.data;
  },

  // Update report
  update: async (id, data) => {
    const response = await api.put(`/${id}`, data);
    return response.data;
  },

  // Delete report
  delete: async (id) => {
    const response = await api.delete(`/${id}`);
    return response.data;
  },

  // Format number with K, M suffix
  formatNumber: (num) => {
    if (!num) return '0';
    if (num >= 1000000) return (num / 1000000).toFixed(1) + 'M';
    if (num >= 1000) return (num / 1000).toFixed(1) + 'K';
    return num.toString();
  },

  // Get week code from date
  getWeekCode: (date = new Date()) => {
    const startOfYear = new Date(date.getFullYear(), 0, 1);
    const days = Math.floor((date - startOfYear) / (24 * 60 * 60 * 1000));
    const weekNumber = Math.ceil((days + startOfYear.getDay() + 1) / 7);
    return `${date.getFullYear()}-W${String(weekNumber).padStart(2, '0')}`;
  },
};

export default tiktokReportService;
